import { Link } from 'react-router';
import { LucideIcon } from 'lucide-react';

interface NavLinkProps {
  path: string;
  label: string;
  icon: LucideIcon;
  isActive: boolean;
  onClick?: () => void;
  mobile?: boolean;
}

export function NavLink({ path, label, icon: Icon, isActive, onClick, mobile = false }: NavLinkProps) {
  if (mobile) {
    return (
      <Link
        to={path}
        onClick={onClick}
        className={`h-[44px] rounded-[10px] px-[16px] flex items-center gap-[12px] transition-all ${
          isActive ? 'bg-[#2a2a35]' : 'hover:bg-[#2a2a35]/50'
        }`}
      >
        <Icon className={`w-[20px] h-[20px] shrink-0 ${isActive ? 'text-white' : 'text-[#9595a5]'}`} />
        <span className={`font-['Inter'] font-normal text-[16px] leading-[24px] ${
          isActive ? 'text-white' : 'text-[#9595a5]'
        }`}>
          {label}
        </span>
      </Link>
    );
  }

  return (
    <Link
      to={path}
      className={`h-[36px] rounded-[10px] px-[16px] flex items-center gap-[8px] transition-all ${
        isActive ? 'bg-[#2a2a35] flex-[1_0_0]' : 'hover:bg-[#2a2a35]/50 shrink-0'
      }`}
    >
      <Icon className={`w-[16px] h-[16px] shrink-0 ${isActive ? 'text-white' : 'text-[#9595a5]'}`} />
      <span className={`font-['Inter'] font-normal text-[14px] leading-[20px] whitespace-nowrap ${
        isActive ? 'text-white' : 'text-[#9595a5]'
      }`}>
        {label}
      </span>
    </Link>
  );
}
